// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Measurement = t.struct({
    unit: t.String,
    value: t.String
}, {
    name: 'Measurement',
    strict: true
});

export const getDefaultState = () => new Measurement({
    unit: '',
    value: ''
});

export default Measurement;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/measurement.js